var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        {
          attrs: { "filter-method": _vm.filterEvent },
          on: { change: _vm.change },
          model: {
            value: _vm.selectedValue,
            callback: function($$v) {
              _vm.selectedValue = $$v
            },
            expression: "selectedValue"
          }
        },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    _vm._l(_vm.renderOptions, function(item) {
      return _c("el-option", {
        key: item[_vm.props.value],
        attrs: { label: item[_vm.props.label], value: item[_vm.props.value] }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6f8dcd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6f8dcd8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SingleSelect.vue
// module id = null
// module chunks = 